import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import { getJson } from 'session';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function OrdinanceRevisionContent({
  handleAddModal,
  handleEdit,
  ordinanceRevisionId,
  getSingleOrdinanceRevision,
  ordinanceRevisionInfo,
}) {
  const permissions = getJson('permissions');

  useEffect(() => {
    if (_.isEmpty(ordinanceRevisionId)) return;
    getSingleOrdinanceRevision(ordinanceRevisionId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(ordinanceRevisionId)) return;
    getSingleOrdinanceRevision(ordinanceRevisionId);
  }, [ordinanceRevisionId]);

  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        <div className="row pt-4 pb-2 bg-white">
          <div className="col-12 d-flex">
            {Acl(permissions, ['BPLS ADD ORDINANCE REVISION']) && (
              <button
                type="button"
                onClick={handleAddModal}
                className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
              >
                Add Ordinance Revision &nbsp;&nbsp;
                <i className="fas fa-plus" />
              </button>
            )}
          </div>
        </div>
        {!_.isEmpty(ordinanceRevisionInfo) ? (
          <React.Fragment>
            <div className="row bg-white pb-3">
              <div className="col-8">
                <h2 className="">
                  {_.get(ordinanceRevisionInfo, 'attributes.name')}
                </h2>
                <span className="full-input">
                  {_.get(ordinanceRevisionInfo, 'attributes.description')}
                </span>
              </div>
              <div className="col-4 d-flex">
                <div className="py-3 ml-auto">
                  {Acl(permissions, ['BPLS UPDATE ORDINANCE REVISION']) && (
                    <button
                      type="button"
                      className="btn-blank"
                      onClick={handleEdit(ordinanceRevisionInfo)}
                    >
                      <i className="far fa-edit icon-edit" />
                    </button>
                  )}
                </div>
              </div>
              <div className="col-12">
                <div className="form-wrapper mb-3 p-3">
                  <table className="transaction-table table table-borderless table-sm ">
                    <tbody>
                      <tr>
                        <td className="text-dark" width="250">
                          Name
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(ordinanceRevisionInfo, 'attributes.name')}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Description
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              ordinanceRevisionInfo,
                              'attributes.description'
                            )}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Year From
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              ordinanceRevisionInfo,
                              'attributes.year_from'
                            )}
                          </b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div className="d-flex align-items-center justitfy-content-center h-100">
            <div className="text-center mx-auto py-4">
              <img
                src={emptyStateImage}
                className="img-responsive image-wrapper mb-4 mt-3"
                alt="Empty State"
              />
              <p className="emp-title mb-0"> No Item Found </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

OrdinanceRevisionContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,

  getSingleOrdinanceRevision: PropTypes.instanceOf(Function).isRequired,
  ordinanceRevisionInfo: PropTypes.instanceOf(Object).isRequired,
  ordinanceRevisionId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  ordinanceRevisionInfo:
    _.get(api, `${c.GET_SINGLE_ORDINANCE_REVISION}.item`) || {},
  ordinanceRevisionId: _.get(match, 'params.ordinanceRevisionId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(OrdinanceRevisionContent);
